import { Component, OnInit } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../globals';
import {DialogService} from '../../../services/dialog.service';
import {MatDialog} from '@angular/material/dialog';
import {EnterpriseConfigurationService} from './enterprise-configuration-service';
import {TdoEnterpriseConfigurationModel} from '../../../models/configuration/tdo-enterprise-configuration.model';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {OrganizationsService} from '../organization-configuration/organizations-service';
import {AddressDataModel} from '../../../models/person/address-data.model';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {OrganizationConfigurationDialogComponent} from '../organization-configuration/dialogs/organization-configuration-dialog/organization-configuration-dialog.component';
import {Constants} from '../../../constants';
import {LocalStorageService} from '../../../services/local-storage.service';
import {EnterpriseService} from '../../../services/enterprise.service';

@Component({
  selector: 'app-enterprise-configuration',
  templateUrl: './enterprise-configuration.component.html',
  styleUrls: ['./enterprise-configuration.component.scss']
})
export class EnterpriseConfigurationComponent implements OnInit {

  enterprise: TdoEnterpriseConfigurationModel;
  organizations: OrganizationDataModel[];
  enterpriseOrganization: OrganizationDataModel;
  tdoOrganization: OrganizationDataModel;
  selectedOrganization: OrganizationDataModel;
  organizationNameRevert: string = '';
  organizationDescriptionRevert: string = '';
  isLoading: boolean = false;
  enumOrganizationTypeId: string = '00000044-1000-0000-0000-000000000008'; // enterprise enumOrganizationTypeId

  constructor(
    private snackBar: MatSnackBar,
    private globals: Globals,
    private dialogService: DialogService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private enterpriseService: EnterpriseService,
    private enterpriseConfigService: EnterpriseConfigurationService,
    private organizationsService: OrganizationsService,
  ) { }

  ngOnInit(): void {
    // get enterprise
    this.isLoading = true;
    this.enterpriseService.getEnterpriseById(this.localStorageService.enterpriseId).subscribe((ent) => {
      if (ent) {
        this.enterprise = ent;
      }
      this.isLoading = false;

      this.loadOrganizations();
    }, err => {
      this.isLoading = false;
      this.createMessage('Error loading enterprise', 'Error');
    });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  onSave(event) {
    this.isLoading = true;

    // save changes to db
    this.enterpriseConfigService.saveEnterprise(this.enterprise).subscribe(saved => {
      if (saved)
      {
        // save successful
        this.createMessage('Enterprise saved', 'Success');
        this.enterprise = saved;

        this.isLoading = false;
      }
    }, err => {
      this.createMessage('Error saving enterprise', 'Error');
      this.isLoading = false;
    });
  }

  openOrganizationDialog(viewOnly: boolean, organizationID: string) {
    const dialogRef = this.dialog.open(OrganizationConfigurationDialogComponent, {
      width: '700px',
      height: '900px',
      panelClass: 'dialog',
      data: {
        isDialogMode: true,
        isViewOnly: viewOnly,
        enumOrganizationTypeId: Constants.emptyGuid, // enterprise enumOrganizationTypeId
        organizationId: organizationID,
        showOrganizationTypeSelection: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (!viewOnly) {
        // re-load organizations
        this.loadOrganizations();
      }
    }, err => {
    });
  }

  onTabChange($event: MatTabChangeEvent) {
    if ($event.index === 0) {
      // editable org
      const orgEdit = this.organizations.find(a => a.OrganizationID === this.enterprise.OrganizationID);
      this.selectedOrganization = orgEdit ? orgEdit : null;
    }
    else {
      // read only org
      const orgTDOc = this.organizations.find(a => a.OrganizationID === this.enterprise.TDOcOrganizationID);
      this.selectedOrganization = orgTDOc ? orgTDOc : null;
    }
  }

  loadOrganizations() {
    // get orgs
    this.enterpriseConfigService.getEnterpriseOrganizations(this.enterprise.EnterpriseID).subscribe((orgs) => {
      this.organizations = orgs;

      // set editable first
      const orgEdit = this.organizations.find(a => a.OrganizationID === this.enterprise.OrganizationID);
      const orgTDOc = this.organizations.find(a => a.OrganizationID === this.enterprise.TDOcOrganizationID);

      if (orgTDOc) {
        this.tdoOrganization = orgTDOc;
        this.setOrganization(orgTDOc);
      }

      if (orgEdit) {
        this.enterpriseOrganization = orgEdit;
        this.setOrganization(orgEdit);
      }

    }, err => {
      this.createMessage('Error loading organizations', 'Error');
    });
  }

  setOrganization(org: OrganizationDataModel) {
    // address
    if (!org.dataAddress) {
      org.dataAddress = new AddressDataModel();
      const newAddress = new AddressDataModel();
      newAddress.LOCID = this.globals.LOCID;
      newAddress.Address1 = '';
      newAddress.Address2 = '';
      newAddress.Address3 = '';
      newAddress.PostCode = '';
      newAddress.State = '';
      newAddress.City = '';
      newAddress.enumAddressCategoryID = '';
      newAddress.Suburb = '';
      org.dataAddress = newAddress;
    }
  }
}
